<template>
<div>
	<transition name="fade">
	<div v-show="!scrolledToBottom" id="quick-add" class="dropup" :class="{ 'with-bottom-menu' : with_bottom_menu }">
		<button 
			class="btn btn-primary btn-circle text-white text-center rounded-circle dropdown-toggle"
			type="button"
			id="dropdownMenuButton"
			data-toggle="dropdown"
			aria-haspopup="true"
			aria-expanded="false">
			<i class="fa fa-plus"></i>
		</button>

		<div class="dropdown-menu py-0">
			<a v-if="perms.can_create_checkin" class="dropdown-item" href="#" data-toggle="modal" data-target="#myModal" @click="buildCheckinModal()" data-test="quickAddCheckin"><i class="fal fa-check-circle"></i>Add Check-in</a>
			<a v-if="perms.can_create_physician" class="dropdown-item" href="#" data-toggle="modal" data-target="#physicianCreateModal" data-test="quickAddPhysician"><i class="fal fa-user-md"></i>Add Physician</a>
			<a v-if="perms.can_create_route" class="dropdown-item" href="#" data-toggle="modal" data-target="#routeCreateModal" data-test="quickAddRoute"><i class="fal fa-route"></i>Add Route</a>
			<router-link :to="{ name: 'tasks' }" class="dropdown-item"><i class="fal fa-tasks"></i>Add Task</router-link>
		</div>
	</div>
</transition>
</div>
</template>

<script>
	import { mapState } from 'vuex';

  	export default {
  		data() {
  			return {
  				scrolledToBottom: false,
  				with_bottom_menu: null,

				checkin_options: {},
  			}
  		},

  		mounted() {
  			this.checkBottomMenu();
  			window.addEventListener('scroll', this.handleScroll);
  		},

  		methods: {
  			buildCheckinModal() {
  				this.$root.$emit('build_checkin_modal', { checkin_options: this.checkin_options });
  			},

  			checkBottomMenu() {
  				if (document.getElementById('bottom-menu')) {
  					this.with_bottom_menu = true;
  				}
  				else {
  					this.with_bottom_menu = false;
  				}
  			},

  			handleScroll() {
				window.onscroll = () => {
				    let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight === document.documentElement.offsetHeight

				    //only do this if mobile sized
				    if (bottomOfWindow && (this.config.layout === 'mobile')) {
				    	this.scrolledToBottom = true;
				    }
				    else {
				    	this.scrolledToBottom = false;
				    }
				 }

  			}
  		},

  		computed: mapState(['config', 'perms']),

		watch:{
		    $route (to, from) {
		        this.checkBottomMenu();
		    }
		} 		
  	}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>